// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_4c1f954","container":"_911f9bd","button":"_71043db","icon":"_1a1778e","menu":"_e359590"};